import { monthYearDateFormat } from "@modules/utils/dateUtils"
import dayjs from "dayjs"

export const defaultMonthValue = dayjs().format(monthYearDateFormat)
